import React from "react";
import IndiaDataCenterMap from "./IndiaDataCenterMap";
import {
  INDIA_MAP_CITIES,
  INTERNATIONAL_LOCATIONS,
} from "../../constant/IndiaMapData";

const HomeDataCenters = () => {
  const totalLocations = INDIA_MAP_CITIES.length + INTERNATIONAL_LOCATIONS.length;

  return (
    <section className="relative w-full rounded-3xl bg-[var(--surface-dark)] py-12 px-4 md:py-16 md:px-8 lg:px-12">
      <div className="mb-8 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--website-secondary-color)]">
          India &amp; international footprint
        </p>
        <h2 className="mt-3 text-3xl font-bold text-white md:text-4xl">
          Explore Our Data Center Locations
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-slate-300 md:text-lg">
          {INDIA_MAP_CITIES.length} cities across India plus{" "}
          {INTERNATIONAL_LOCATIONS.length} international location
          {INTERNATIONAL_LOCATIONS.length === 1 ? "" : "s"} ({totalLocations}{" "}
          total). Hover or tap a location to view services, or click through
          for full details.
        </p>
      </div>

      <div className="mx-auto max-w-none">
        <IndiaDataCenterMap />
      </div>
    </section>
  );
};

export default HomeDataCenters;
